import * as kea from "kea-react";
import * as React from "react";
import * as models from "app/models/requireme";
import { AbonoRepFactura } from "app/models/requireme";
import { unionKey, firstMap, createSelector, allEqual, all, any } from "keautils";

import { columnas, toGridItems } from "./columnas";
import { componentToRx } from "../../../../main/std";


interface Props {
    items: models.FacturaDto[];
    onQuitarItem: (x: models.FacturaDto) => void;
    value: AbonoRepFactura[];
    onChange: (x: AbonoRepFactura[]) => void;
}



/**Listado de las facturas a las que abona un REP */
class ListaFacturaRepNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    items = (props: Props) => props.items;
    itemsGrid = createSelector(this.items, this.value, toGridItems);

    onQuitar = (it: models.FacturaDto) => this.props.onQuitarItem(it);

    onMontoChange = (it: models.FacturaDto, monto: number) => {
        const old = this.props.value;
        const next = unionKey(old, [{
            IdFactura: it.IdRegistro,
            Monto: monto
        } as AbonoRepFactura], x => x.IdFactura);

        this.props.onChange(next);
    }

    getMontoFactura = (x: models.FacturaDto) => firstMap(this.value(this.props), y => y.IdFactura == x.IdRegistro, y => y.Monto) || 0;

    columnas = columnas({
        getMontoFactura: this.getMontoFactura,
        onMontoChange:  this.onMontoChange,
        onQuitar: this.onQuitar
    });

    render() {
        const items = this.itemsGrid(this.props);
        return (
            <div>
                <kea.Grid2
                    items={items}
                    columnas={this.columnas}
                    hideBusqueda
                />
            </div>
        )
    }
}

export const ListaFacturaRep = componentToRx(ListaFacturaRepNoRx);


// WEBPACK FOOTER //
// ./app/features/componentes/facturas/pagos/list.tsx